import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface RehabImpMarketsMstParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface RehabImpMarketsMst {
    id?: any;
    name:string;

    parameters?: RehabImpMarketsMstParameter[];
    links?: any;
}


export abstract class RehabImpMarketsMstData {
    abstract list(url: string): Observable<RehabImpMarketsMst[]>;
    abstract create(url: string, data: RehabImpMarketsMst): Observable<RehabImpMarketsMst[]>;
    abstract update(url: string, data: RehabImpMarketsMst): Observable<RehabImpMarketsMst>;
    abstract delete(url: string): Observable<any>;
}
